module.exports = __webpack_public_path__ + "img/adnuntius.00370f1.png";